// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__39XFc","subheader":"ReorderModal_subheader__lQPTn","listWrap":"ReorderModal_listWrap__tz7LW"};